import { Children, FC } from 'react';
import styled from 'styled-components';
import { PlaceholderList } from '../ContentPlaceholder/PlaceholderList';
import { DropdownButton } from '../DropdownButton/DropdownButton';
import { DropdownButtonItem } from '../DropdownButton/DropdownButtonItem';
import { Message } from '../Message/Message';

const ListElement = styled.div`
  background-color: white;
`;

const HeaderElement = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

const TitleElement = styled.h3`
  text-transform: uppercase;
  font-size: 12px;
  margin: 0;
`;
const DescriptionElement = styled.div`
  color: ${({ theme }) => theme.vars.newColor.darkGS3};
`;

export interface AccessibleRoleProp {
  /**
   * Optional aria-role for the parent element
   */
  role?: string;
}

export interface IProps extends AccessibleRoleProp {
  children?: any;
  heading?: string;
  menuItems?: any[];
  description?: string;
  icon?: string;
  emptyMsg?: string;
  loading?: boolean;
  numPlaceholderLines?: number;
}

export const List: FC<IProps> = props => (
  <ListElement {...props} data-testid="ListElement">
    {props.heading && (
      <HeaderElement role="heading">
        <div>
          {props.heading && <TitleElement>{props.heading}</TitleElement>}
          {props.description && <DescriptionElement>{props.description}</DescriptionElement>}
        </div>

        <div>
          {props.menuItems && (
            <DropdownButton variation="clean" icon="plus-circle">
              {props.menuItems.map((i, index) => (
                <DropdownButtonItem key={index} onClick={i.onClick}>
                  {i.label}
                </DropdownButtonItem>
              ))}
            </DropdownButton>
          )}
        </div>
      </HeaderElement>
    )}
    {props.loading && <PlaceholderList numItems={Children.count(props.children) || 3} />}
    {!props.loading && Children.count(props.children) === 0 && <Message>{props.emptyMsg || 'No items'}</Message>}
    <div>{!props.loading && props.children}</div>
  </ListElement>
);

List.defaultProps = { role: 'list' };
